import safeCreateAction from "../../../actions/safeCreateAction";
export const loadCategories = safeCreateAction("LOAD_CATEGORIES", (gameId, gameCategories) => ({
    gameId,
    gameCategories,
}));
export const setCategory = safeCreateAction("SET_CATEGORY", (gameId, id, category) => ({
    gameId,
    id,
    category,
}));
export const removeCategory = safeCreateAction("REMOVE_CATEGORY", (gameId, id) => ({ gameId, id }));
export const setCategoryOrder = safeCreateAction("SET_CATEGORY_ORDER", (gameId, categoryIds) => ({ gameId, categoryIds }));
export const updateCategories = safeCreateAction("UPDATE_CATEGORIES", (gameId, gameCategories) => ({
    gameId,
    gameCategories,
}));
export const renameCategory = safeCreateAction("RENAME_CATEGORY", (gameId, categoryId, name) => ({
    gameId,
    categoryId,
    name,
}));
